import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/fire-calculator',
  component: () => import('../../routes/FIRECalculator.svelte'),
  card: {
    id: 'fire-calculator',
    title: 'FIRE Calculator',
    description: 'Plan Financial Independence and early retirement. Calculate your FI number, years to FI, and required savings rate.',
    icon: 'local_fire_department',
    iconBgClass: 'bg-orange-50',
    iconTextClass: 'text-orange-600',
    href: '/fire-calculator',
    category: 'Retirement & Tax',
  },
  seo: {
    title: 'FIRE Calculator – Financial Independence Retire Early Calculator',
    description: 'Free FIRE calculator for Financial Independence, Retire Early planning. Calculate your FI number, years to FI, required savings rate, and monthly savings needed to reach early retirement. Includes 4% safe withdrawal rule and inflation-adjusted projections.',
  },
};

export default meta;
